"use client";
import React, { useState } from "react";

const DEFAULT_FAQS = [
  {
    question: "Do you ship from China and other international locations?",
    answer: [
      "Yes, we have extensive networks in China, Asia-Pacific, Europe, and North America.",
      "We handle imports and exports from major manufacturing hubs including Guangzhou, Shenzhen, Shanghai, and Hong Kong.",
      "Our international shipping services include sea freight, air freight, and express courier options.",
    ],
  },
  {
    question: "What shipping methods do you offer?",
    answer: [
      "We offer multiple shipping options: Express (1-3 days), Standard (3-7 days), Economy (7-14 days), and Freight services.",
      "Available methods include air freight, sea freight, ground transportation, and same-day delivery in select cities.",
    ],
  },
  {
    question: "How can I track my shipment?",
    answer: [
      "Enter your tracking number on our website or mobile app for real-time updates.",
      "Our tracking system provides detailed location information and estimated delivery times.",
    ],
  },
  {
    question: "Do you handle customs clearance for international shipments?",
    answer: [
      "Yes, our experienced customs brokerage team handles all import/export documentation.",
      "We manage customs clearance, duty calculations, and regulatory compliance.",
    ],
  },
  {
    question: "Do I need to create an account to ship with you?",
    answer: [
      "Individual customers can ship without an account, but creating one provides better rates and tracking history.",
      "Business accounts are required for corporate rates, invoicing, and advanced shipping features.",
      "Account setup is free and takes just a few minutes.",
    ],
  },
  {
    question: "What countries do you ship to?",
    answer: [
      "We ship to over 220 countries and territories worldwide.",
      "Popular destinations include USA, Canada, UK, Australia, Germany, and throughout Asia-Pacific.",
      "Some remote locations may have extended delivery times or additional fees.",
    ],
  },
  {
    question: "Do you offer insurance for shipments?",
    answer: [
      "Yes, we provide comprehensive shipping insurance to protect your valuable items.",
      "Basic coverage is included, with additional insurance available for high-value shipments.",
      "Claims are processed quickly with our dedicated support team.",
    ],
  },
  {
    question: "What payment methods do you accept?",
    answer: [
      "We accept all major credit cards, PayPal, bank transfers, and corporate invoicing.",
      "Cash on delivery (COD) is available in select markets.",
    ],
  },
  {
    question: "Do you offer pickup services?",
    answer: [
      "Yes, we provide free pickup for shipments in major cities.",
      "Scheduled pickups are available Monday-Friday, with same-day pickup in metro areas.",
      "Additional fees may apply for residential pickups or remote locations.",
    ],
  }
];

const FAQS = ({ faqs: propFaqs }) => {
  const faqs = (propFaqs && propFaqs.length > 0) ? propFaqs : DEFAULT_FAQS;
  const [activeAccordion, setActiveAccordion] = useState(null);

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  return (
    <section id="faqs" className="py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-16">
          <h2 className="text-4xl font-manrope text-center font-bold text-blue-500 leading-[3.25rem]">
            FAQS Answered
          </h2>
        </div>
        <div className="accordion-group">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`accordion border border-solid border-gray-300 p-4 rounded-xl transition duration-500 mb-8 lg:p-4 ${
                activeAccordion === index ? "bg-gray-200 border-blue-500" : ""
              }`}
            >
              <button
                className={`accordion-toggle group inline-flex items-center justify-between text-left text-lg font-normal leading-8 text-gray-900 w-full transition duration-500 hover:text-blue-500 ${
                  activeAccordion === index ? "font-medium text-blue-500" : ""
                }`}
                onClick={() => toggleAccordion(index)}
                aria-expanded={activeAccordion === index}
              >
                <h5>{faq.question}</h5>
                <svg
                  className={`w-6 h-6 text-gray-900 transition duration-500 ${
                    activeAccordion === index ? "hidden" : "block"
                  } group-hover:text-blue-500`}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 12H18M12 18V6"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <svg
                  className={`w-6 h-6 text-gray-900 transition duration-500 ${
                    activeAccordion === index ? "block" : "hidden"
                  } group-hover:text-blue-500`}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 12H18"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <div
                className={`accordion-content w-full overflow-hidden pr-4 transition-max-height duration-500 ${
                  activeAccordion === index ? "max-h-96" : "max-h-0"
                }`}
                aria-labelledby={`basic-heading-${index}`}
              >
                <ul className="text-base text-gray-900 font-normal leading-6 list-disc ml-6">
                  {faq.answer.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQS;
